// extracted by mini-css-extract-plugin
export default {"pages":"Pages_pages__gamOi","page":"Pages_page__eOyfw","grid":"Pages_grid__OLd3b","fadeIn":"Pages_fadeIn__VkGn-"};